var map = {
	"./bgloding.vue": "paqw",
	"./carousel.vue": "yytp",
	"./footerTab.vue": "cmnB",
	"./helloWorld.vue": "gKrF",
	"./login.vue": "K31e",
	"./navbar.vue": "J56h",
	"./newsCard.vue": "binu",
	"./newsListAll.vue": "M4Pv",
	"./newsListOther.vue": "D0DG",
	"./newsListZC.vue": "Cfsl",
	"./nodate.vue": "5/7M",
	"./orderCard.vue": "NtXB",
	"./pcard.vue": "HQ5R",
	"./productImg.vue": "ReP+",
	"./prompt.vue": "ZpX4"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ZBoC";


//////////////////
// WEBPACK FOOTER
// ./src/components \.vue$
// module id = ZBoC
// module chunks = 12